// extracted by mini-css-extract-plugin
module.exports = {"root":"QAReports_root__2xLe6"};